import {Button} from '@/components/ui/button/Button'
import {DotsHorizontalIcon, Pencil01Icon, Trash01Icon} from '@/components/ui/icon/Icon'
import {Menu, MenuGroup, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'

export const TreatmentRequestFollowUpMenu = ({
    onClickEdit,
    onClickDelete
}: {
    onClickEdit: () => void
    onClickDelete: () => void
}) => {
    const {t} = useTranslation()

    return (
        <MenuProvider>
            <MenuButton
                render={
                    <Button variant="ghost" shape="square">
                        <DotsHorizontalIcon />
                    </Button>
                }
            />
            <Menu portal={false}>
                <MenuGroup>
                    <MenuItem onClick={onClickEdit}>
                        <Pencil01Icon />
                        {t('commons:edit')}
                    </MenuItem>
                </MenuGroup>
                <MenuGroup>
                    <MenuItem variant="danger" onClick={onClickDelete}>
                        <Trash01Icon />
                        {t('commons:delete')}
                    </MenuItem>
                </MenuGroup>
            </Menu>
        </MenuProvider>
    )
}
